import axios from 'axios'
import { API_URL } from '../../../../constants'
import { ApiResponse } from '../../../common/api/response.types'
import { IMyLedgerBalances } from './types'

export const getMyLedgerBalances = () =>
  axios.get<ApiResponse<IMyLedgerBalances>>(`${API_URL}/api/internal/ledger-wallet-balance/my`)
